import * as Constants from '@/lib/constants'

const DEFAULT_ZOOM_LEVEL = 18

export default {
  computed: {
    currentMapCenter() {
      return this.$store.getters.currentMapCenter
    },
    zoomLevel() {
      return DEFAULT_ZOOM_LEVEL
    },
  },
}
